import { ThemeRepository } from "@common/domain/repositories/ThemeRepository";
import { call, ForkEffect, select, takeLatest, put } from "redux-saga/effects";
import {
  DELETE_THEME_DATA,
  FETCH_ACTIVE_THEME_ID,
  GET_ALL_THEME_DATA,
  SAVE_THEME_DATA,
} from "./constants";
import { updateThemeId } from "../formBuilder/actions";
import {
  getAllThemeDataSuccess,
  updateThemeDataSucess,
  updateThemeDataFailure,
  updateFetchThemeLoader,
  getAllThemeDataFailure,
} from "./actions";
import {
  IAllThemeDataPayload,
  IDeleteThemeDataAction,
  IFetchFromCdnAction,
  IGetAllThemeDataAction,
  IRequestBodyData,
  ISaveThemeDataAction,
  IThemeData,
  IThemeInitalState,
} from "./interface";

function* saveThemeDataSaga(action: ISaveThemeDataAction) {
  try {
    const themeData = action.payload.themeData;
    const themeIdPayload = action.payload.themeIdPayload ?? "";
    const onSuccess = action.payload?.onSuccess;
    // const state = yield select((state) => state.formBuilder);
    const requestBody: IRequestBodyData = { themeData };
     if (themeIdPayload && themeIdPayload != "") {
      requestBody.themeId = themeIdPayload;
      delete themeData.themeId;
    }
    if (themeData.name) {
      requestBody.name = themeData.name;
      delete themeData.name;
    }
    if (themeData.description) {
      requestBody.description = themeData.description;
      delete themeData.description;
    }
    const response = yield call(ThemeRepository.saveThemeData, requestBody);
    const themeId = response?.themeId ?? "";
    yield put(updateThemeId(themeId));
    onSuccess && onSuccess(themeId);
  } catch (e) {
    console.log(e);
  }
}
function* getAllThemeDataSaga(action: IGetAllThemeDataAction) {
  try {
    const onSuccess = action.payload?.onSuccess;
    const response: IAllThemeDataPayload[] = yield call(
      ThemeRepository.getAllThemeData
    );
    onSuccess?.();
    yield put(getAllThemeDataSuccess(response));
  } catch (e) {
    yield put(getAllThemeDataFailure());
    console.log(e);
  }
}

function* getThemeByIdAction(action: IFetchFromCdnAction) {
  const themeId = action.payload.themeId;
  try {
    const disableUpdate = action.payload.disableUpdate;
    const disableLoader = action.payload.disableLoader;
    if (!disableLoader) yield put(updateFetchThemeLoader());
    const onSuccess = action.payload?.onSuccess;
    const response: IThemeData = yield call(
      ThemeRepository.getThemeById,
      themeId
    );
    if (!disableUpdate)
      yield put(
        updateThemeDataSucess(response?.data?.themeData as IThemeInitalState)
      );
    onSuccess && onSuccess(response?.data?.themeData);
  } catch (e) {
    yield put(updateThemeDataFailure());
  }
}

function* deleteThemeDataSaga(action: IDeleteThemeDataAction) {
  try {
    const themeId = action.payload.themeId;
    const onSuccess = action.payload?.onSuccess;
    yield call(ThemeRepository.deleteThemeData, themeId);
    onSuccess && onSuccess();
  } catch (e) {
    const onFailure = action.payload?.onFailure;
    onFailure && onFailure();
  }
}

export function* watchTheme(): Generator<ForkEffect> {
  yield takeLatest(SAVE_THEME_DATA, saveThemeDataSaga);
  yield takeLatest(GET_ALL_THEME_DATA, getAllThemeDataSaga);
  yield takeLatest(FETCH_ACTIVE_THEME_ID, getThemeByIdAction);
  yield takeLatest(DELETE_THEME_DATA, deleteThemeDataSaga);
}
